import { useMemo } from 'react';
import { useNotesContext } from '../../../../contexts/NotesContext';

const useNotesForAnchor = (anchorId) => {
  const { notesByAnchorId } = useNotesContext();

  // Sort notes by title
  const sortedNotes = useMemo(
    () =>
      (notesByAnchorId[anchorId] ?? []).sort((a, b) =>
        a.title.localeCompare(b.title),
      ),
    [notesByAnchorId, anchorId],
  );

  return sortedNotes;
};

export default useNotesForAnchor;
